import { MiModal } from "@miplatform/components";
import {
  BUTTON_COLORS,
  BUTTON_VARIANTS,
  TYPOGRAPHY_VARIANTS,
} from "@miplatform/constants";
import { mdiClockOutline } from "@mdi/js";
import { Typography, useTheme } from "@mui/material";

export const Push24hOrderModal = ({ open, onClose, onPush, isLoading }) => {
  const theme = useTheme();

  const handleSubmit = async () => {
    await onPush();
  };

  return (
    <MiModal
      open={open}
      closeModal={onClose}
      width={330}
      titleIcon={mdiClockOutline}
      leftIconColor={theme.palette.blue.main}
      title="Push 24h"
      loading={isLoading}
      actions={[
        {
          name: "Close",
          variant: BUTTON_VARIANTS.TEXT,
          color: BUTTON_COLORS.BLACK,
          onClick: onClose,
        },
        {
          name: "Push 24h",
          color: BUTTON_COLORS.BLUE,
          variant: BUTTON_VARIANTS.CONTAINED,
          disabled: isLoading,
          onClick: handleSubmit,
        },
      ]}
    >
      <Typography
        variant={TYPOGRAPHY_VARIANTS.SUBTITLE2}
        color="grey"
        mb={2}
        px={2}
      >
        Pushing an order will reschedule it by 24 hours. All associated
        assignments will be updated accordingly.
      </Typography>
    </MiModal>
  );
};
